import React from 'react'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import 'dayjs/locale/pt-br'

type Props = Partial<React.ComponentProps<typeof DatePicker>> & {
  clearable?: boolean
  setValue: React.Dispatch<React.SetStateAction<dayjs.Dayjs | null>>
}

const DateInput: React.FC<Props> = ({ value, setValue, clearable, ...props }) => {
  const [error, setError] = React.useState("")

  const errorMessage = React.useMemo(() => {
    switch (error) {
      case 'disablePast': {
        return `Deve ser igual ou após à data de hoje ${dayjs().format('DD/MM/YYYY')}`
      }
      case 'minDate': {
        return `Deve ser igual ou após à data de ${props.minDate?.format('DD/MM/YYYY')}`
      }
      default: {
        return ''
      }
    }
  }, [error])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DatePicker
        value={value}
        label={props.label ?? 'Data'}
        onChange={(newValue) => setValue(newValue)}
        sx={{ width: '20rem' }}
        onError={(newError) => setError(newError)}
        slotProps={{
          field: { clearable: clearable, onClear: () => setValue(null) },
          textField: {
            helperText: errorMessage || " ",
            InputLabelProps: { shrink: true },
            inputProps: { 'data-testid': 'date-input' },
          },
        }}
        {...props}
      />
    </LocalizationProvider>
  )
}

export default DateInput
